export * from './src/bookings-catalog-search-v1-catalog-search-catalog-search.universal.js';
